import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayout7Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "10", width: "6", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "10", y: "10", width: "6", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "2", y: "2", width: "14", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconGridLayout7Fill18.js.map